import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
// import { AlertComponent } from '../sharedModule/alertModule/alert.component';
// import { DynamicComponentService } from './dynamicComponent.service';
// import { TranslateService } from '@ngx-translate/core';
import { UserMenuComponent } from '../sharedModule/userMenuModule/user-menu.component';
import { v4 as uuidv4 } from 'uuid';

@Injectable({ providedIn: 'root' })
export class CommonService {
	public macFirstLoad: boolean = true;
	public logs: any;
	public loading = [];
	public leftPanel;
	public filterBar;
	public filter;
	public defaultPage;
	public dateTimePicker;
	public urlHistories = [];
	public userMenuComponent:UserMenuComponent;
	public sectionComponent:any;
	public keydownListeners = [];
	public postMessageListeners:any = [];
	constructor() {

		this.logs = [];

        /*
        if(window)
        {
            window.addEventListener('error', this.onError.bind(this));
        }
        */
		window.onerror = (error, url, line) => {

			// this.logError('Error:' + error);
			this.error('URL:' + url);
			this.error('Error:' + line + ":"+ error);
			// console.log(error, url, line, a,b,c);
			// this.logError(error)
			// VM10463:1 Uncaught Error: ABC
			// at <anonymous>:1:7
		};
	}

    /*
    private onError(event)
    {
        this.logError("ERROR");
    }
    */
	//---------------------------------------------------------------------------------------------
	public getProperty = function (obj, path) {
		path = path.split('.');
		var current = obj;
		while (path.length) {
			if (typeof current !== 'object') return undefined;
			current = current[path.shift()];
		}
		return current;
	}
	//---------------------------------------------------------------------------------------------
	public debugText: string = "";
	private appendLog(obj:any):void
	{
		this.logs.push(obj);
		if(this.logs.length > 100)
		{
			this.logs.shift();
		}
	}
	public logType(type:string, item:any):Promise<void>
	{
		return new Promise((resolve, reject) => {
			if (environment.production) {
				resolve();
			} else {
				console.log(item);
				if(item == "OK")
				{
					debugger;
				}
				var logObject:any;
				try {
					logObject = {
						time: this.getDateString(),
						text: JSON.stringify(item),
						type: type
					};
				} catch (err) {
					logObject = {
						time: this.getDateString(),
						text: item,
						type: type
					};
					
					// this.debugText = this.getDateString() + '   ' + item + "\n\n" + this.debugText;
				} finally {
					this.appendLog(logObject);
					resolve();
				}
				//if (this.debugText.length>10000) this.debugText = this.debugText.substr(0, 10000);
			}
		});
	}
	public error(item: any): Promise<any> 
	{
		return this.logType("error", item);
	}
	public info(item:any): Promise<any> {
		return this.logType("info", item);
	}
	public log(item: any): Promise<any> {
		return this.logType("log", item);
	}
	//---------------------------------------------------------------------------------------------
	private readonly envMap = { 'localhost': 'Localhost', 'dev.': 'Dev', 'uat.': 'Uat', 'pre.': 'Pre-prod' };
	private getEnvByHostname(hostname: string): string {
		const matchedPrefix = Object.keys(this.envMap).find(prefix => {
			if (prefix === 'localhost') return hostname === 'localhost';
			return hostname.split('.').length > 2 && hostname.startsWith(prefix);
		});
		return this.envMap[matchedPrefix] || '';
	}
	//---------------------------------------------------------------------------------------------
	public verStr(ver: string): string {
		const envType = environment.type.charAt(0).toUpperCase() + environment.type.slice(1);
		const host = this.getEnvByHostname(window.location.hostname);
		return "v" + ver + (environment.production ? "" : " (" + envType + ".Mode) " + ( host ? "site:" + host + "+" : " " ) + "db:" + environment.db);
	}//---------------------------------------------------------------------------------------------
	public getVersion(moduleName:string=null):string {
		return moduleName ? (environment.versions && environment.versions[moduleName]) || '0.0.0' : environment.version;
	}
	//---------------------------------------------------------------------------------------------
	public getVersionString(moduleName: string): string {
		//let versionString: string = (environment.versions && environment.versions[moduleName]) || '0.0.0';
		let versionString:string = this.getVersion(moduleName);
		const envType = environment.type.charAt(0).toUpperCase() + environment.type.slice(1);
		const host = this.getEnvByHostname(window.location.hostname);
		return "v" + versionString + (environment.production ? "" : " (" + envType + ".Mode) " + ( host ? "site:" + host + "+" : " " ) + "db:" + environment.db);
	}
	//---------------------------------------------------------------------------------------------
	public zIndex: number = 105;
	public getZIndex(): number {
		setTimeout(()=>{this.zIndex++;}, 0);
		return this.zIndex + 1;
	}
	public setZIndex(zIndex: number): void {
		setTimeout(()=>{this.zIndex = zIndex;});
	}

	public resetZIndex(): void {
		this.zIndex = 105;
	}
	//---------------------------------------------------------------------------------------------
	public getDateString(d:Date=new Date(), format:string='yyyymmddhhmmss', dateDelimiter:string='-', timeDelimiter:string=':', dateTimeDelimiter:string=' ', use24hrs:boolean=true):string {
		let pad = (v: number): string => {
			return ((v < 10) ? '0' : '') + v;
		}
        if (isNaN(+d)) return '';
        let year = d.getFullYear();
        let month = pad(d.getMonth() + 1);
        let day = pad(d.getDate());
        let hour = pad((!use24hrs && d.getHours() > 12) ? d.getHours() - 12 : d.getHours());
        let min = pad(d.getMinutes());
        let sec = pad(d.getSeconds());
        let apm = use24hrs ? '' : (d.getHours() > 11) ? ' pm' : ' am';
        //YYYYMMDDhhmmss
        //return year+month+day+hour+min+sec
        //YYYY-MM-DD hh:mm:ss
        format = format.toLowerCase();
        if (format=='yyyymmddhhmmss') return year + dateDelimiter + month + dateDelimiter + day + dateTimeDelimiter + hour + timeDelimiter + min + timeDelimiter + sec + apm;
        if (format=='yyyymmddhhmm') return year + dateDelimiter + month + dateDelimiter + day + dateTimeDelimiter + hour + timeDelimiter + min + apm;
        if (format=='yyyymmdd') return year + dateDelimiter + month + dateDelimiter + day;
		if (format=='ddmmyyyy') return day + dateDelimiter + month + dateDelimiter + year;
		if (format=='hhmmss') return hour + timeDelimiter + min + timeDelimiter + sec + apm;
        if (format=='hhmm') return hour + timeDelimiter + min + apm;
	}
	//---------------------------------------------------------------------------------------------
	public async waitFor(conditionFn: Function, chance: number = 3, delay: number = 1000, startDelay: number = 0): Promise<any> {

		let result: any;
		let error: any;
		if (startDelay > 0) {
			await this.timeout(startDelay);
		}
		do {
			chance--;
			try {
				result = await conditionFn();
			} catch (e) {
				error = e;
			}
			if (result) {
				return result;
			}
			await this.timeout(delay);

		} while (chance > 0);

		throw error || 'waitFor(' + conditionFn.toString() + ') retryEnd';

		// return new Promise((resolve, reject)=>{
		//     chance--;
		//     let result:any;
		//     let err:any;
		//     try { result = conditionFn(); } catch(e) { err = e; }
		//
		//     if (result) {
		//         // resolve(result);
		// 		setTimeout(()=>{resolve(result);}, startDelay);
		//     } else if (chance>0) {
		//         setTimeout(()=>{
		//             resolve(this.waitFor(conditionFn, chance, delay));
		//         }, delay);
		//     } else {
		//         reject(err || 'waitFor(' + conditionFn.toString() + ') retryEnd');
		//     }
		// }).catch((e)=>{
		// 	console.log(e);
		// });
    }
    //---------------------------------------------------------------------------------------------
	public isEmailFormatValid(email:string):boolean {
		const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
		return re.test(String(email).toLowerCase());
	}

	public timeout(ms: number): Promise<void> {
		return new Promise((resolve, reject) => {
			setTimeout(resolve, ms);
		});
	}

	public audioPlay(src:any = null, options:any = {}){
		const flag = sessionStorage.getItem("userInteracted");//for user Interaction; not sure work
		options.removeOther = options.removeOther === undefined?false:options.removeOther;
		options.repeat = options.repeat === undefined?false:options.repeat;
		options.volume = options.volume === undefined?1:options.volume;
		let els:any = document.querySelectorAll('body > audio.ro');
		if (src == null || options.removeOther){
			if (els.length > 0){
				els.forEach(el=>{
					el.pause();
					el.remove();
				});
			}
			if (src == null){
				return Promise.resolve(null);
			}
		}
		let el = document.createElement('audio');
		el.classList.add('ro');
		if (options.className){
			el.classList.add(options.className);
		}
		if (options.muted){
			el.muted = true;
		}
		document.body.appendChild(el);
		el.src = src;
		if (options.repeat){
			el.setAttribute('loop','true');
		}
		el.volume = options.volume;
		return new Promise((resolve, reject)=>{
			el.play().then(()=>{
				el.addEventListener('ended', ()=>{
					if (!options.repeat){
						el.remove();
					}
					resolve(null);
				});
			}).catch((error)=>{
				reject(error);
			});
		});
	}

	public isWebView():boolean {
		const ua = navigator.userAgent.toLowerCase();

		// 加額外參數判定是否 app call
		if(location.search.indexOf('CFA=1') != -1)
		{
			sessionStorage.setItem('CFA', '1'); // for ios debug 時 reload page 後，還記得是 app call 狀態
			return true;
		} else if(sessionStorage.getItem('CFA') == '1'){
			return true;
		}

		// AIR SDK iOS 未支援設定 UserAgent
		if(ua.indexOf('rainbowsky') != -1)
			return true;

		// 有 'www.rainbowsky.ai' 代表是 rainbowsky app call
		// 有 'api.openknowledge.hk' 代表是 rainbowone app call
		return location.host.indexOf('www.rainbowsky.ai') != -1 || location.host.indexOf('api.openknowledge.hk') != -1;


		// 由於有第三方 browser 會用 webview 做，所以棄用 webview detect 的方案
		/*

		return (
			// Android WebView
			ua.includes('wv') ||
			// macOS/iPadOS web view
			(ua.includes('macintosh') && ua.includes('applewebkit/') && !ua.includes('version/') && !ua.includes('safari/')) ||
			// iOS 且非 Safari
			(/iphone|ipad|ipod/.test(ua) && !ua.includes('safari')) ||
			// 包含 webview 字樣但非 Chrome
			(ua.includes('webview') && !ua.includes('chrome')) ||
			// 檢查是否有原生橋接
			!!(window.hasOwnProperty('android') || (window.hasOwnProperty('webkit') && window['webkit'].messageHandlers)) ||
			// edge / chrome 會有 webview 變數
			(window.hasOwnProperty('chrome') && window['chrome'].hasOwnProperty('webview')) ||
			// IE 當是 app
			(ua.indexOf('msie ') > -1 || ua.indexOf('trident/') > -1)
		);
		*/
	}

	public isPhone():boolean {
		const ua = navigator.userAgent;
		
		if (/iPhone/.test(ua))
			return true;

		// 1. 確認是 Android
		if (!/Android/i.test(ua))
			return false;

		// 获取屏幕尺寸
		const screenWidth = window.screen.width;
		const screenHeight = window.screen.height;
		const dpr = window.devicePixelRatio || 1;
		
		// 计算物理尺寸（英寸）
		const physicalWidth = screenWidth / dpr;
		const physicalHeight = screenHeight / dpr;
		const diagonalInches = Math.sqrt(
			Math.pow(physicalWidth / 96, 2) + 
			Math.pow(physicalHeight / 96, 2)
		);

		return diagonalInches < 7;
	}

	public getViewPort():any {
		if(window.visualViewport)
			return window.visualViewport;
		return {width:window.innerWidth, height:window.innerHeight};
	}

	public uuidv4() {
		return uuidv4();
	}

	public number_to_hex_color(num: number): string {
		return "#" + num.toString(16).padStart(6, "0");
	}

	public getMaxZIndex() {
		let maxZ = 0;
		const elements = document.querySelectorAll('body *');
		const ignoreSelectors = [
			'#ot-sdk-btn-floating',
			'#onetrust-pc-sdk',
			'#onetrust-consent-sdk',
			'p-toast > ui-toast',
			'ng-component > div.layer'
		];

		// Helper function to check if an element is within any ignored SDK
		const isIgnored = (element) => {
			return ignoreSelectors.some(selector => {
            try {
                return element.matches(selector);
            } catch (e) {
                console.warn(`Invalid selector: ${selector}`, e);
                return false;
            }
        });
		};

		elements.forEach(element => {
			if (isIgnored(element)) {
				return;
			}

			const zIndex = parseInt(window.getComputedStyle(element).zIndex);
			if (!isNaN(zIndex) && zIndex > maxZ) {
				maxZ = zIndex;
			}
		});
		return maxZ + 1;
	}
}
